/**
 * cartManager.js
 * Handles the sticky cart panel functionality including
 * size selection and price updates.
 */

class CartManager {
  constructor(options = {}) {
    // DOM Elements
    this.priceDisplay = document.getElementById('price-amount');
    this.sizeInputs = document.querySelectorAll('input[name="size"]');
    this.buyNowButton = document.getElementById('buy-now');
    
    // Options with defaults
    this.options = {
      prices: options.prices || {
        small: 299,
        medium: 499,
        large: 699
      },
      onBuyNow: options.onBuyNow || null
    };
    
    // Initialize
    this.init();
  }
  
  init() {
    // Add event listeners for size selection
    if (this.sizeInputs) {
      this.sizeInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.updatePrice(input.value);
        });
      });
    }
    
    // Add event listener for buy now button
    if (this.buyNowButton) {
      this.buyNowButton.addEventListener('click', () => {
        const selectedSize = this.getSelectedSize();
        const price = this.options.prices[selectedSize];
        
        if (this.options.onBuyNow) {
          this.options.onBuyNow({
            size: selectedSize,
            price: price
          });
        }
      });
    }
    
    // Set initial price
    this.updatePrice(this.getSelectedSize());
  }
  
  getSelectedSize() {
    const selectedInput = Array.from(this.sizeInputs).find(input => input.checked);
    return selectedInput ? selectedInput.value : 'small';
  }
  
  updatePrice(size) {
    const price = this.options.prices[size];
    if (price !== undefined && this.priceDisplay) {
      this.priceDisplay.textContent = price;
    }
  }
}

// Export
window.CartManager = CartManager;